import { Environment, Lightformer } from '@react-three/drei';
import { Canvas } from '@react-three/fiber';
import { Physics } from '@react-three/rapier';
import { type ReactNode, type RefObject, Suspense } from 'react';
import { Badge } from './Badge';

export function CredentialCanvas({
  face,
  eventSource,
  onDraggingChange,
}: {
  face: ReactNode;
  eventSource?: RefObject<HTMLElement | null>;
  onDraggingChange?: (dragging: boolean) => void;
}) {
  return (
    <Canvas
      camera={{ position: [0, 0, 13], fov: 25 }}
      gl={{ alpha: true }}
      eventSource={
        eventSource ? (eventSource as RefObject<HTMLElement>) : undefined
      }
      style={{ background: 'transparent', pointerEvents: 'none' }}
    >
      <ambientLight intensity={Math.PI} />
      <Suspense fallback={null}>
        <Physics interpolate gravity={[0, -15, 0]} timeStep={1 / 60}>
          <Badge face={face} onDraggingChange={onDraggingChange} />
        </Physics>
      </Suspense>
      <Environment blur={0.75}>
        <Lightformer
          intensity={2}
          color="white"
          position={[0, -1, 5]}
          rotation={[0, 0, Math.PI / 3]}
          scale={[100, 0.1, 1]}
        />
        <Lightformer
          intensity={3}
          color="white"
          position={[-1, -1, 1]}
          rotation={[0, 0, Math.PI / 3]}
          scale={[100, 0.1, 1]}
        />
        <Lightformer
          intensity={3}
          color="white"
          position={[1, 1, 1]}
          rotation={[0, 0, Math.PI / 3]}
          scale={[100, 0.1, 1]}
        />
        <Lightformer
          intensity={10}
          color="white"
          position={[-10, 0, 14]}
          rotation={[0, Math.PI / 2, Math.PI / 3]}
          scale={[100, 10, 1]}
        />
      </Environment>
    </Canvas>
  );
}
